import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

// islemTuru: "Ekleme", "Silme", "Güncelleme", "Giriş"
// detay: Ekranda görünecek mesaj
// yapanKisi: auth.currentUser.email
// hedefId (Opsiyonel): Tıklayınca gidilecek kaydın ID'si
// hedefSayfa (Opsiyonel): 'cariler', 'tedarikciler' vb.

export const logIslem = async (islemTuru, detay, yapanKisi = "Sistem", hedefId = null, hedefSayfa = null) => {
  try {
    await addDoc(collection(db, 'islem_gecmisi'), {
      islemTuru: islemTuru,
      detay: detay,
      yapan: yapanKisi,
      hedefId: hedefId,      // YENİ: Tıklama için ID
      hedefSayfa: hedefSayfa, // YENİ: Hangi sayfaya gidecek
      zaman: serverTimestamp()
    });
    console.log("Log kaydedildi:", detay);
  } catch (error) {
    console.error("Loglama hatası:", error);
  }
};